import { Injectable } from '@angular/core';
import { LoggerService } from '@app/logger/logger.service';
import { ApiBaseService } from './api-base.service';

const log = new LoggerService('SUBSTITUTES SERVICE');

@Injectable({
  providedIn: 'root'
})
export class SubstitutesService extends ApiBaseService<any>{

  constructor() {
    // Le pasamos 'substitutes' como el nombre del recurso a la clase base
    super('substitutes');
    log.debug('Servicio de Sustitutos inicializado');
  }

}
